export const ShouldRender = ({ children, when }) => (
  when ? children : null
);
